<template>
    <div class="base-tree-item"
         :class="{
         'is-has-child':data[props.children] && data[props.children].length,
         'is-hide':!idei,
         'is-online':data.online+''==='1'}"
         v-if="data"
         :item-id="generateId">
        <div class="tree-item-label-wrap"
             :style="{paddingLeft:`${level*12}px`}">
            <span class="tree-item-arrow tree-item-switch"></span>
            <span class="tree-item-label tree-item-switch"
                  :class="{
                  'line':data[props.tag]==='line',
                  'vehicle':data[props.tag]==='vehicle',
                  'channel':data[props.tag]==='channel'}">{{data[props.label]}}</span>
        </div>
        <div class="tree-item-child">
            <template v-for="(child,index) in data.children"
                      v-if="data.children && data.children.length">
                <base-tree-item :data="child"
                                :key="index"
                                :level="level+1"
                                :props="props"
                                :generate-id-rules="generateIdRules"
                                :is-default-expand="isDefaultExpand"
                                :index="index"/>
            </template>
        </div>
    </div>
</template>
<script>
    export default {
        name: "BaseTreeItem",
        props: {
            data: Object,
            props: Object,
            index: [String, Number],
            level: {
                type: Number,
                default: 1
            },
            generateIdRules: Function,
            isDefaultExpand: Function
        },
        mounted () {
            this.$el.treeData = this.data;
        },
        updated () {
            this.$el.treeData = this.data;
        },
        computed: {
            idei () {
                return this.isDefaultExpand(this.data, this.index, this.level);
            },
            generateId () {
                return this.generateIdRules(this.data, this.props.label);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// base-tree-item.vue?701c60a2